import { Alert, Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";
import { BlueprintConfigurationError } from "../../../../models/Blueprints";
import { BlueprintRunnerTestRunStatusBadge } from "../../../shared/MergeBadges";
import LeftPanelSectionHeader from "../shared/LeftPanelSectionHeader";

interface Props {
  error: BlueprintConfigurationError;
  onViewStep: () => void;
}

const BlueprintLeftPanelConsoleValidationError = ({ error, onViewStep }: Props) => (
  <>
    <hr className="bg-gray-10 p-0 m-0" />
    <div className="flex flex-col space-y-4 py-4">
      <LeftPanelSectionHeader title="Results" badge={<BlueprintRunnerTestRunStatusBadge />} />
      <Alert color="red">
        <div className="flex flex-col space-y-2">
          <Text variant="h6" className="text-red-60">
            Blueprint validation error
          </Text>
          <Text>{error.message}</Text>
          <Text variant="sm" className="text-gray-40">
            Step: <code>{error.step_id}</code>
          </Text>
          <Text variant="sm" className="text-gray-40">
            Field: <code>{error.parameter_path}</code>
          </Text>
        </div>
      </Alert>
      <Button variant={ButtonVariant.SecondaryGray} onClick={onViewStep} fullWidth={true}>
        View affected step
      </Button>
    </div>
  </>
);

export default BlueprintLeftPanelConsoleValidationError;
